var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "47px",
    viewBox: "0 0 48 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Abstract/06",
    transform: "translate(-9.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#9AE0EA",
    points: "9 9 9 56 22.7142857 56 22.7142857 22.4285714 57 22.4285714 57 9",
    className: "fill-dynamic-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "icon-color-base",
    cx: 47,
    cy: 45,
    r: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon07);
export default __webpack_public_path__ + "static/media/icon07.93e0e7ab89c56cd38ae944666c2b4cd3.svg";
export { ForwardRef as ReactComponent };